import { TableCell, TableHead, Table, TableBody, TableRow, TableFooter, Button, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import TimeHelper from '../../../../../utils/time';
import { useTranslation } from 'react-i18next';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import { ReturnCommand } from '../../../../../services/command';

function ReturnStatusHistoryDrawer({ returnId, onClose }: any) {
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);
    const { t } = useTranslation();
    const handleClose = () => {
        if (onClose) onClose();
    };
    useEffect(() => {
        ReturnCommand.ReturnStatusHistory({ returnId }).then((res) => {
            if (res) {
                console.info(res);
                setData(res);
            }
            setLoading(false);
        });
    }, []);
    if (loading) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '36px',
                    height: '100%',
                    width: '100%',
                }}
            >
                <CircularProgress size={40} />
            </div>
        );
    }
    return (
        <div style={{ padding: '2rem' }}>
            {data ? (
                <>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h2 style={{ color: '#5b99f3', marginBottom: '2rem' }}>{t('return.returnStatusHistory')}</h2>

                        <Button>
                            <CloseIcon style={{ height: 'auto', width: '25px' }} onClick={handleClose} />
                        </Button>
                    </div>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{t('orderDetail.date')}</TableCell>
                                <TableCell> {t('orderDetail.user')}</TableCell>
                                <TableCell>{t('general.status')}</TableCell>
                                <TableCell>{t('general.storeCode')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row: any, index: number) => (
                                <TableRow key={index}>
                                    <TableCell>{TimeHelper.formatDateHour(row.date)}</TableCell>
                                    <TableCell>{row.userName}</TableCell>
                                    <TableCell>{row.returnStatusDescription}</TableCell>
                                    <TableCell>{row.storeCode?.length > 0 ? row.storeCode : ' - '}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={3} />
                                <TableCell align="right">
                                    {t('orderDetail.totalRecordsCount')} {data.length}
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </Table>
                </>
            ) : (
                <div
                    style={{
                        color: '#666463',
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '2rem',
                    }}
                >
                    <HighlightOffIcon style={{ width: '40px', height: 'auto' }} />
                    <h2 style={{ marginLeft: '2rem' }}>{t('return.returnStatusHistory')}</h2>
                </div>
            )}
        </div>
    );
}

export default ReturnStatusHistoryDrawer;
